import { render, staticRenderFns } from "./ParceiroList.vue?vue&type=template&id=c4f99e40&scoped=true&"
import script from "./ParceiroList.vue?vue&type=script&lang=js&"
export * from "./ParceiroList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f99e40",
  null
  
)

export default component.exports